// Copyright (c) 2019 Deere & Company

import t from 'tcomb';

const Notification = t.struct({
    language: t.String,
    shortText: t.String,
    title: t.String,
    url: t.String,
}, {
    name: 'Notification',
    strict: false,
});

export const getDefaultState = () => new Notification({
    language: '',
    shortText: '',
    title: '',
    url: '',
});

export default Notification;
